import { render } from "./EventList.vue?vue&type=template&id=c1ff0892&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=c1ff0892&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c1ff0892"

export default script